import React from "react";
import { Chip, makeStyles } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    chip: {
      borderRadius: "5px",
      border: "1px solid #ffe082",
      color: "#ffe082",
      background: "transparent"
    },
    published: {
      border: "1px solid #77ffb5",
      color: "#77ffb5"
    },
    draft: {
      border: "1px solid #999",
      color: "#fff"
    }
  };
});

var CourseStatusChip = function CourseStatusChip(_ref) {
  var status = _ref.status,
      label = _ref.label,
      style = _ref.style;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Chip, {
    label: label ? label : status.toUpperCase(),
    className: [classes.chip, classes[status]].join(" "),
    style: style
  });
};

export { CourseStatusChip };